/**
 * Component: Create the Look
 * ------------------------------------------------------------------------------
 * Handles add-to-cart behaviour for Create the Look collections.
 *
 */

/**
 * Selectors.
 */

var selectors = {
  addToCart: '[js-add-to-cart]',
  decrement: '[js-create-the-look="decrement"]',
  increment: '[js-create-the-look="increment"]',
  maxQuantityInput: '[js-create-the-look="maxQuantityInput"]',
  miniCart: '.mini-cart',
  miniCartItemWrapper: '.mini-cart-item-wrapper',
  productForm: '[js-create-the-look="productForm"]',
  quantityInput: '[js-create-the-look="quantityInput"]',
  quickAdd: '[js-create-the-look="quickAdd"]',
};

/**
 * Node selectors.
 */

var nodeSelectors = {
  addToCart: document.querySelectorAll(selectors.addToCart),
  miniCart: document.querySelector(selectors.miniCart),
  miniCartItemWrapper: document.querySelector(selectors.miniCartItemWrapper),
  productForm: document.querySelectorAll(selectors.productForm),
  quickAdd: document.querySelectorAll(selectors.quickAdd),
};

/**
 * Handle quantity increment/decrement
 * @param {Element} productForm - The product form.
 */
function handleQuantitySelect(productForm) {
  var decrement = productForm.querySelector(selectors.decrement);
  var increment = productForm.querySelector(selectors.increment);
  var quantityInput = productForm.querySelector(selectors.quantityInput);
  var maxQuantityInput = productForm.querySelector(selectors.maxQuantityInput);

  var initQuantity = parseInt(quantityInput.value, 10);
  var initMaxQuantity = parseInt(maxQuantityInput.value, 10);

  initQuantity === 1 && decrement.classList.add('disabled');
  initQuantity === initMaxQuantity && increment.classList.add('disabled');

  decrement.addEventListener("click", function(event) {
    event.preventDefault();

    var quantity = parseInt(quantityInput.value, 10);
    var newValue = quantity === 1 ? quantity : quantity - 1;

    quantityInput.value = newValue;
    increment.classList.remove('disabled');
    decrement.classList.toggle('disabled', newValue === 1)
  });

  increment.addEventListener("click", function(event) {
    event.preventDefault();

    var quantity = parseInt(quantityInput.value, 10);
    var maxQuantity = parseInt(maxQuantityInput.value, 10);
    var newValue = quantity === maxQuantity ? quantity : quantity + 1;

    quantityInput.value = newValue;
    decrement.classList.remove('disabled');
    increment.classList.toggle('disabled', newValue === maxQuantity);
  });

  quantityInput.addEventListener("blur", function() {
    var quantity = parseInt(quantityInput.value, 10);
    var maxQuantity = parseInt(maxQuantityInput.value, 10);

    if (quantity <= 0 || quantityInput.value.trim().length <= 0 || isNaN(quantity)) {
      quantityInput.value = 1;
    }

    if (quantity > maxQuantity) {
      quantityInput.value = maxQuantity;
    }
  })
};

/**
 * Handle add to cart event
 * @param {Element} addToCart - Add to cart button.
 */
function handleAddToCart(addToCart) {
  var form = addToCart.closest('form');
  var productForm = addToCart.closest(selectors.productForm);

  $.ajax({
    method: 'POST',
    url: '/cart/add.js',
    data: $(form).serialize(),
    dataType: 'json',
  })
  .done(function(response) {
    productForm.classList.add("is-added");
    addToCart.setAttribute('value', Theme.addedToCartText);
    setTimeout(function() {
      productForm.classList.remove("is-added");
      productForm.classList.remove("is-active");
      addToCart.setAttribute('value', Theme.addToCartText);
    }, 1500);
    clearProductFormActiveClass();
    window.ProductView.loadAjaxCart(true);
  })
  .fail(function(error) {
    window.console.error(error);
  });
}

/**
 * Remove active class from all product forms
 */
function clearProductFormActiveClass() {
  for (let i = 0; i < nodeSelectors.productForm.length; i++) {
    nodeSelectors.productForm[i].classList.remove('is-active');
  }
}

/**
 * Set event listeners
 */
function setEventListeners() {
  for (let i = 0; i < nodeSelectors.quickAdd.length; i++) {
    nodeSelectors.quickAdd[i].addEventListener("click", function(event) {
      event.preventDefault();

      var productForm = event.target.closest(selectors.productForm);

      handleQuantitySelect(productForm);
      clearProductFormActiveClass();
      productForm.classList.add('is-active');
    });
  }

  if (window.innerWidth < 1024) {
    for (let i = 0; i < nodeSelectors.addToCart.length; i++) {
      nodeSelectors.addToCart[i].addEventListener("click", function(event) {
        event.preventDefault();

        handleAddToCart(event.target);
      });
    }

  } else {
    for (let i = 0; i < nodeSelectors.addToCart.length; i++) {
      nodeSelectors.addToCart[i].addEventListener("click", function(event) {
        event.preventDefault();

        var productForm = event.target.closest(selectors.productForm);

        if (productForm.classList.contains('is-active')) {
          handleAddToCart(event.target);

          return;
        }

        handleQuantitySelect(productForm);
        clearProductFormActiveClass();
        productForm.classList.add('is-active');
      });
    }
  }

  document.body.addEventListener("click", function(event) {
    var productForm = event.target.closest(selectors.productForm);

    if (productForm !== null) {
      return;
    }

    clearProductFormActiveClass();
  });
};

/**
 * Initialize component
 */
function init() {
  setEventListeners();
};

init();
